import { render } from "./AdvertisementOptions.vue?vue&type=template&id=1c20097a&scoped=true"
import script from "./AdvertisementOptions.vue?vue&type=script&lang=js"
export * from "./AdvertisementOptions.vue?vue&type=script&lang=js"

import "./AdvertisementOptions.vue?vue&type=style&index=0&id=1c20097a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c20097a"]])

export default __exports__